import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, authStore } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // null = checking, false = signed out, object = user
  const [user, setUser] = useState(null);

  const refresh = useCallback(async () => {
    if (!authStore.get()) {
      setUser(false);
      return;
    }
    try {
      const u = await api.me();
      setUser(u);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const signIn = async ({ email, password, code }) => {
    const { token, user: u } = await api.login({ email, password, code });
    authStore.set(token);
    setUser(u);
    return u;
  };

  const finishSignup = async ({ email, password, code }) => {
    const { token, user: u } = await api.verify2FASetup({ email, password, code });
    authStore.set(token);
    setUser(u);
    return u;
  };

  const signOut = () => {
    authStore.clear();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, signIn, finishSignup, signOut, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
